export const FEATURE_UI_CONFIG: Record<
  string,
  {
    showInput: boolean;
    showOutput: boolean;
    inputLabel: string;
    outputLabel?: string;
  }
> = {
  // input + output
  ttt: {
    showInput: true,
    showOutput: true,
    inputLabel: "Input Language",
    outputLabel: "Output Language",
  },
  ms_ttt: {
    showInput: true,
    showOutput: true,
    inputLabel: "Input Language",
    outputLabel: "Output Language",
  },
  vt: {
    showInput: true,
    showOutput: true,
    inputLabel: "Input Language",
    outputLabel: "Output Language",
  },
  vt_w_vc: {
    showInput: true,
    showOutput: true,
    inputLabel: "Input Language",
    outputLabel: "Output Language",
  },

  // only language
  stt: {
    showInput: true,
    showOutput: false,
    inputLabel: "Language",
  },
  tts: {
    showInput: true,
    showOutput: false,
    inputLabel: "Language",
  },
  tts_w_vc: {
    showInput: true,
    showOutput: false,
    inputLabel: "Language",
  },
  ms_stt: {
    showInput: true,
    showOutput: false,
    inputLabel: "Language",
  },
  ms_tts_w_vc: {
    showInput: true,
    showOutput: false,
    inputLabel: "Language",
  },

  // subtitle language
  vs: {
    showInput: true,
    showOutput: false,
    inputLabel: "Subtitle Language",
  },
};
